var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 2.07156L13.7143 1.89052C12.581 1.67978 11.419 1.67978 10.2857 1.89052C10.0114 1.94225 9.74572 2.00259 9.48 2.07156C9.59804 1.48693 9.9134 0.961313 10.3727 0.583777C10.8319 0.206241 11.4068 0 12 0C12.5932 0 13.1681 0.206241 13.6273 0.583777C14.0866 0.961313 14.402 1.48693 14.52 2.07156ZM18.06 5.11466C16.8613 3.90941 15.3342 3.08866 13.6717 2.75618C12.0092 2.4237 10.2861 2.59442 8.7201 3.24675C7.15411 3.89908 5.81557 5.00373 4.8737 6.42105C3.93183 7.83838 3.42893 9.50475 3.42857 11.2095V18.106H20.5714V11.2095C20.5759 10.0768 20.3561 8.95454 19.925 7.90813C19.4938 6.86173 18.8598 5.91212 18.06 5.11466ZM22.2857 18.9681H1.71429C1.25963 18.9681 0.823593 19.1498 0.502103 19.4731C0.180612 19.7964 0 20.235 0 20.6922C0 21.1495 0.180612 21.5881 0.502103 21.9114C0.823593 22.2347 1.25963 22.4164 1.71429 22.4164H22.2857C22.7404 22.4164 23.1764 22.2347 23.4979 21.9114C23.8194 21.5881 24 21.1495 24 20.6922C24 20.235 23.8194 19.7964 23.4979 19.4731C23.1764 19.1498 22.7404 18.9681 22.2857 18.9681Z",
    fill: "#43927C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 24.9995C12.9467 24.9995 13.7142 24.2276 13.7142 23.2754H10.2856C10.2856 24.2276 11.0532 24.9995 11.9999 24.9995Z",
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFill);
export default __webpack_public_path__ + "static/media/bellFill.366e2fe928a55d6a637474149b32f4a9.svg";
export { ForwardRef as ReactComponent };